import React, { ReactElement, useState } from 'react';
import { Navigate } from 'react-router';

interface CanStorePrivateRouteProps {
	children: ReactElement;
}

function CanStorePrivateRoute({ children }: CanStorePrivateRouteProps): JSX.Element {
	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

	return isAuthenticated ? children : <Navigate to="/can-store/login" replace={true} />;
}

export default CanStorePrivateRoute;
